// import React, { useContext, useRef, useEffect } from 'react'
// import { AuthContext } from '../context/AuthContext'
// import { ChatContext } from '../context/ChatContext';

// const Messages2 = (message) => {

//   const { currentUser } = useContext(AuthContext);
//   const {data} = useContext(ChatContext);

//   const ref = useRef();

//   useEffect(() => {
//     ref.current?.scrollIntoView({ behavior: "smooth" });
//   }, [message]);

//   return (
//     <div ref = {ref} 
//     className={`message2 ${message.senderId === currentUser.uid && 'owner'}`}>

//         <div className="msginfo">
//         <img src={message.senderId === currentUser.uid 
//          ? currentUser.photoURL :data.user.photoURL }
//         alt="" />
//         <span>Just Now</span>
//         </div>

//         <div className="msgContant">
//         <p>{message.text}</p>
//        {message.img && <img src={message.img}
//         alt="" />}
//         </div>
//     </div>
//   )
// }

// export default Messages2


import React, { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import { ChatContext } from "../context/ChatContext";

const Messages2 = ({ message }) => {
  const { currentUser } = useContext(AuthContext);
  const { data } = useContext(ChatContext);

  const ref = useRef();

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);

  return (
    <div
      ref={ref}
      className={`message2 ${message.senderId === currentUser.uid && "owner"}`}
    >
      <div className="msginfo">
        <img
          src={
            message.senderId === currentUser.uid
              ? currentUser.photoURL
              : data.user.photoURL
          }
          alt="" />
          
        <span>{new Date().toLocaleTimeString()}</span>
      </div>
      <div className="msgContant">
        <p>{message.text}</p>
        {message.img && <img src={message.img} alt="" />}
      </div>
    </div>
  );
};

export default Messages2;